module.exports = __webpack_public_path__ + "static/media/worker_inactive_sel.4ee1cc27.svg";